// extracted by mini-css-extract-plugin
module.exports = {"mandatory":"AssignLabelsModal-module_mandatory_2c55c"};